import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import InsertEmoticonIcon from '@material-ui/icons/InsertEmoticon';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles({
  root: {
    minHeight: 300,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  font: {
    fontSize: 60,
    background: '#DFDFDF',
    width: 200,
    height: 200,
    padding: 50,
    borderRadius: '50%',
  },
  pos: {
    marginBottom: 12,
    textAlign: 'center',
  },
});

export default function FallbackCard({ text }) {
  const classes = useStyles();

  return (
    <Card className={classes.root}>
      <CardContent>
        <div>
          <InsertEmoticonIcon htmlColor="#fff" className={classes.font} />
        </div>
        <br />
        <Typography className={classes.pos} color="secondary">
          {text}
        </Typography>
      </CardContent>
    </Card>
  );
}
